import React, { useState } from 'react';
import StarsBackground from './components/StarsBackground';
import Profile from './components/Profile/Profile';
import SocialLinks from './components/Profile/SocialLinks';
import ArcadeZone from './components/Arcade/ArcadeZone';
import CommentSection from './components/Comments/CommentSection';
import AuthBar from './components/Auth/AuthBar';
import AuthModal from './components/Auth/AuthModal';
import AdminPanel from './components/Admin/AdminPanel';
import { useAuth } from './context/AuthContext';

export default function App() {
  const [authOpen, setAuthOpen] = useState(false);
  const [authMode, setAuthMode] = useState('login');
  const [adminOpen, setAdminOpen] = useState(false);
  const { user } = useAuth();

  const openAuth = (mode) => {
    setAuthMode(mode);
    setAuthOpen(true);
  };

  return (
    <div className="app-root">
      <StarsBackground />
      <AuthBar onOpenAuth={openAuth} onOpenAdmin={() => setAdminOpen(true)} />
      <main className="main-container">
        <Profile />
        <SocialLinks />
        <ArcadeZone onRequireAuth={() => openAuth('login')} />
        <CommentSection onRequireAuth={() => openAuth('login')} />
      </main>
      {authOpen && (
        <AuthModal
          mode={authMode}
          onClose={() => setAuthOpen(false)}
          onSwitchMode={(m) => setAuthMode(m)}
        />
      )}
      {adminOpen && user?.role === 'admin' && (
        <AdminPanel onClose={() => setAdminOpen(false)} />
      )}
    </div>
  );
}
